"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshAccessToken = exports.logout = exports.setCookieValue = exports.getCookieValue = void 0;
const getCookieValue = (name) => {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : null;
};
exports.getCookieValue = getCookieValue;
const setCookieValue = (name, value) => {
    document.cookie = `${name}=${value}; Path=/;`;
};
exports.setCookieValue = setCookieValue;
const logout = () => {
    (0, exports.setCookieValue)('authToken', '');
    (0, exports.setCookieValue)('refreshToken', '');
};
exports.logout = logout;
const refreshAccessToken = async (authConfig) => {
    if (!authConfig) {
        throw new Error('No auth configuration available');
    }
    const refreshToken = (0, exports.getCookieValue)('refreshToken');
    if (!refreshToken) {
        throw new Error('You are not logged in');
    }
    const response = await fetch(`${authConfig.redirectUrl}?grant_type=refresh_token&refresh_token=${refreshToken}`, {
        method: 'GET',
        credentials: 'include',
    });
    if (!response.ok) {
        (0, exports.logout)();
        throw new Error('Failed to refresh token');
    }
    const data = await response.json();
    (0, exports.setCookieValue)('authToken', data.access_token);
    return data.access_token;
};
exports.refreshAccessToken = refreshAccessToken;
